import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import ImageZoom from "./ImageZoom";
import * as Dialog from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

function PromoHome() {
    const [catalogData, setCatalogData] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        fetch('/data/catalog.json?t=' + Date.now())
            .then((res) => res.json())
            .then((data) => {
                const today = new Date();
                const filtered = data.filter((item) => {
                    const start = new Date(item.start_date);
                    start.setHours(0, 0, 0, 0);
                    const end = new Date(item.end_date);
                    end.setHours(23, 59, 59, 999);
                    return today >= start && today <= end;
                });
                setCatalogData(filtered);
            });
    }, []);

    const handleImageClick = (img) => {
        setSelectedImage(img);
        setOpen(true);
    };

    const closePopup = () => {
        setOpen(false);
    };

    return (
        <>
            {catalogData.length > 0 ? (
                <div className="promo-home pt-[25px] md:pt-[64px] px-[10px] md:px-[50px] lg:px-[70px] lg:px-[100px] bg-[#F1F8FF]">
                    <div className="flex justify-between mb-5">
                        <div><h3 className="text-sky-500 text-xs md:text-xl lg:text-2xl xl:text-3xl font-extrabold font-nunito">Hot deals waiting! Check our promo & drop by!</h3></div>
                        <div>
                            <div className="relative md:pt-1 lg:pt-2">
                                <Link to="/promo"><h5 className="text-sky-500 text-[8px] md:text-sm lg:text-md xl:text-xl font-extrabold underline mr-0 md:mr-6 mt-1 md:mt-0">Find Out More!</h5></Link>
                                <div className="absolute right-0 md:-bottom-2 lg:-bottom-2 xl:-bottom-3">
                                    <img src={`${process.env.PUBLIC_URL}/media/images/icon-link.png`} className="hidden md:flex md:h-[20px] lg:h-[20px] xl:h-[24px]" alt="FamilyMart Indonesia" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="border-1 md:border-2 border-solid border-cyan-600 my-5" />
                    <div className="flex flex-col md:flex-row px-0 md:px-5">
                        {catalogData.map((catalog, index) => {
                            if (index == 0) return (
                                <div className="flex-1 px-0 md:[px-7]" key={index}>
                                    <img src={catalog.image} alt={catalog.image} onClick={() => handleImageClick(catalog.image)} />
                                </div>
                            );
                            if (index == 1) return (
                                <div className="hidden md:flex flex-1 px-7" key={index}>
                                    <img src={catalog.image} alt={catalog.image} onClick={() => handleImageClick(catalog.image)} />
                                </div>
                            );
                        })}

                        {/* Modal Zoom */}
                        <Dialog.Root open={open} onOpenChange={setOpen}>
                            <Dialog.Portal>
                                <Dialog.Overlay className="fixed inset-0 bg-black/80 z-40" />
                                <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 p-4 rounded shadow-xl max-w-5xl w-full">
                                    <Dialog.Title>
                                        <VisuallyHidden>Image Preview</VisuallyHidden>
                                    </Dialog.Title>
                                    <Dialog.Description>
                                        <VisuallyHidden>Image Description</VisuallyHidden>
                                    </Dialog.Description>
                                    {/* Konten Modal */}
                                    <div className="absolute inset-0" onClick={closePopup}></div>
                                    <button
                                        onClick={closePopup}
                                        className="absolute top-4 right-4 z-20 text-white text-3xl font-bold"
                                    >
                                        &times;
                                    </button>
                                    <img
                                        src={selectedImage}
                                        alt={`Zoomed`}
                                        className="w-full object-contain max-h-screen mx-auto"
                                    />
                                </Dialog.Content>
                            </Dialog.Portal>
                        </Dialog.Root>
                    </div>
                    <hr className="border-1 md:border-2 border-solid border-cyan-600 mt-5" />
                </div>
            ) : (<></>)}
        </>
    );
}

export default PromoHome;
